import { Injectable } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { StoreService } from "./store.service";
import { environment } from "src/environments/environment";
import { HttpClient } from "@angular/common/http";
import { ErrorReporting } from "../common.interface";

@Injectable({
    providedIn: "root",
})
export class CommonService {
    baseUrl = `${environment.baseUrl}`;

    constructor(
        private toastr: ToastrService,
        private store: StoreService,
        private httpClient: HttpClient
    ) {}

    updateToken(req: { notificationToken: string }) {
        return this.httpClient.post<any>(`${this.baseUrl}/customer/notification/subscribe/token`, req);
    }

    getCompanyManualAddressSearch(searchText: string, endPoint: string) {
        return this.httpClient.post<any>(`${environment.baseUrl}${endPoint}`, {
            search: searchText,
        });
    }

    getAddressUsingLatLong(
        details: {
            latitude: number;
            longitude: number;
        },
        endPoint: string
    ) {
        return this.httpClient.post<any>(`${environment.baseUrl}${endPoint}`, details);
    }

    getCompanyManualAddressSearchWithPlaceId(endPoint: string, placeId: string) {
        return this.httpClient.get<any>(`${environment.baseUrl}${endPoint}/${placeId}`);
    }

    getContactDetails() {
        return this.httpClient.get<any>(`${this.baseUrl}/contact-us/list`);
    }

    getCustomerProfile() {
        return this.httpClient.get<any>(`${this.baseUrl}/customer-profile/get`);
    }

    errorReporting(req: ErrorReporting) {
        return this.httpClient.post<any>(`${environment.ERROR_REPORTING}`, req);
    }

    getSurveyList(params: any) {
        return this.httpClient.get<any>(`${environment.baseUrl}/survey/list`, {
            params: params,
        });
    }

    surveySubmit(surveyData: any) {
        return this.httpClient.post<any>(`${environment.baseUrl}/survey/submit`, surveyData);
    }

    loanDecline() {
        return this.httpClient.put<any>(`${environment.baseUrl}/decline/loan/application`, {});
    }

    downloadSummaryPdf(
        pdfTemplateType: string,
        applicationId: string,
        paymentResponseId?: string,
        tenure?: number,
        loanAmount?: number,
        couponCode?: string
    ) {
        const payload: any = {
            pdfTemplateType,
            applicationId,
        };

        if (paymentResponseId) payload.paymentResponseId = paymentResponseId;
        if (tenure) payload.tenure = tenure;
        if (loanAmount) payload.loanAmount = loanAmount;
        if (couponCode) payload.couponCode = couponCode;

        return this.httpClient.post<any>(`${environment.baseUrl}/download-pdf-details/pdf/download`, payload);
    }
}
